import {
  takeLatest,
  put,
  select,
} from 'redux-saga/effects';
import { dashboardsSelector } from '@store/tempDashboard/selectors';
import * as types from './types';

function* initTempDashboard(action) {
  const { tempDashboardId } = action;

  const dashboards = yield select(dashboardsSelector);

  const tempDashboard = dashboards[tempDashboardId];

  if (!tempDashboard || !tempDashboard.dashboard) {
    return;
  }
  yield put({ type: types.START_FETCHING });
  const { dashboard } = tempDashboard;

  try {
    let data = null;
    data = dashboard.base;

    yield put({ type: types.END_FETCHING });
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* watchInitTempDashboard() {
  yield takeLatest([
    types.INIT_TEMP_DASHBOARD,
  ], initTempDashboard);
}

export default [
  watchInitTempDashboard,
];
